import { createContext, useContext, type ReactNode } from "react";
import type { EpisodeSummary, HeroPublic, Me } from "@scrile/contracts";

/**
 * Данные, которые нужны почти каждому экрану: герой (по хосту), кто вошёл, серии.
 * Загружает их App; экраны только читают и просят перезагрузить после входа или оплаты.
 */
export interface HeroData {
  hero: HeroPublic;
  me: Me | null;
  episodes: EpisodeSummary[];
  /** Серии пришли хотя бы раз: до этого список показывает загрузку, а не «пусто». */
  episodesReady: boolean;
  /** Текст ошибки последней загрузки серий — список показывает его с кнопкой повтора. */
  episodesError: string | null;
  setMe(me: Me | null): void;
  reloadMe(): Promise<Me | null>;
  reloadEpisodes(): Promise<EpisodeSummary[]>;
}

const HeroDataContext = createContext<HeroData | null>(null);

export function HeroDataProvider({ value, children }: { value: HeroData; children: ReactNode }) {
  return <HeroDataContext.Provider value={value}>{children}</HeroDataContext.Provider>;
}

export function useHeroData(): HeroData {
  const data = useContext(HeroDataContext);
  if (!data) throw new Error("useHeroData outside of HeroDataProvider");
  return data;
}
